import {
  Divider,
  EDividerVariant,
  EHeadingStyleVariant,
  ETextStyleVariant,
  Grid,
  GridItem,
  Heading,
  Text,
} from '@outdoorsyco/bonfire';
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import { CAMPER, CAMPING, HEART, MONEY } from '@/components/switchback/Icon/assets';
import Icon from '@/components/switchback/Icon/IconComponent';

import styles from './BecomeAHost.module.css';

export const HostBenefits = () => {
  const intl = useIntl();
  const rvBenefits = [
    {
      icon: <Icon width={38} height={38} name={MONEY} />,
      title: intl.formatMessage({ defaultMessage: 'Earn', id: 'W9cTVS' }),
      description: intl.formatMessage({
        defaultMessage: 'each time you host — $688 million paid to hosts since 2015',
        id: 'jsFvej',
      }),
    },
    {
      icon: <Icon width={38} height={38} name={CAMPER} />,
      title: intl.formatMessage({ defaultMessage: 'Partner', id: 'MToUjW' }),
      description: intl.formatMessage({
        defaultMessage: 'with the top innovator in RV rentals',
        id: 'NP5ToH',
      }),
    },
    {
      icon: <Icon width={38} height={38} name={CAMPING} />,
      title: intl.formatMessage({ defaultMessage: 'Share', id: 'OKhRC6' }),
      description: intl.formatMessage({
        defaultMessage: 'your love of travel and the outdoors',
        id: 'KVWx3m',
      }),
    },
    {
      icon: <Icon width={38} height={38} name={HEART} />,
      title: intl.formatMessage({ defaultMessage: 'Connect', id: '+vVZ/G' }),
      description: intl.formatMessage({
        defaultMessage: 'with a 30,000-strong community of hosts',
        id: 'edyQDC',
      }),
    },
  ];

  const rvCta = (
    <Heading variant={EHeadingStyleVariant.H4} className="mx-auto mt-12 text-center max-w-40">
      <FormattedMessage
        defaultMessage="All with the assurance of up to $1 million liability coverage every trip"
        id="8AEeri"
      />
    </Heading>
  );

  return (
    <section className={`${styles.spacing} bg-white`}>
      <Grid spacing={6} className="m-0">
        {rvBenefits.map(({ title, icon, description }) => (
          <GridItem sm={3} xs={12} key={title} className="flex flex-col items-center text-center">
            {icon}
            <Heading variant={EHeadingStyleVariant.H4} className="my-4">
              {title}
            </Heading>
            <Text variant={ETextStyleVariant.MediumRegular} className="max-w-[240px]">
              {description}
            </Text>
          </GridItem>
        ))}
      </Grid>
      <Divider
        variant={EDividerVariant.Horizontal}
        width="110px"
        className="py-8 mx-auto border-b-4 border-b-canvas-100"
      />
      {rvCta}
    </section>
  );
};
